import { FC } from 'react'
import styled, { css } from 'styled-components'
import { ArrowRight, Check } from 'svgIcons'
import useRightSection from '@app.feature/jobCategory/hooks/useRightSection'
import RightItem from './RightItem'

interface IFRightSectionProps {
  className?: string
}

const RightSection: FC<IFRightSectionProps> = ({ className }) => {
  const {
    isSecondDepth,
    allTargetCategory,
    isAllChecked,
    rightSectionItem,
    onItemClick,
    onAllClick,
  } = useRightSection()

  return (
    <StyledWrapper className={className}>
      {allTargetCategory && (
        <RightItem
          label="전체"
          onClick={() => {
            onAllClick()
          }}
          endAdornment={isAllChecked && <Check className="check-icon" />}
          className={isAllChecked ? 'select-item' : ''}
        />
      )}
      {rightSectionItem.map((item) => {
        const getEndAdornment = () => {
          if (isSecondDepth) {
            return <ArrowRight className="arrow-right" />
          }

          if (item.isSelect) {
            return <Check className="check-icon" />
          }

          return null
        }

        return (
          <RightItem
            key={item.id}
            label={item.name}
            onClick={() => {
              onItemClick(item)
            }}
            endAdornment={getEndAdornment()}
            className={item.isSelect ? 'select-item' : ''}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default RightSection

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    overflow: auto;

    .arrow-right {
      width: 16px;
      height: 16px;
      padding: 2px;
      color: ${theme.color.hint_1};
    }

    .check-icon {
      width: 16px;
      height: 16px;
      padding: 2px;
      color: ${theme.color.primary_2};
    }

    .select-item {
      color: ${theme.color.primary_2};
      font-weight: 500;
    }
  `}
`
